<template>
  <div>
    <div class="row clients">
      <div class="col-md-8 col-sm-12 offset-md-2">

        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
						<span class="m-portlet__head-icon m--hide">
						<i class="la la-gear"></i>
						</span>
                <h3 class="m-portlet__head-text">
                  Clients
                </h3>
              </div>
            </div>
            <div class="m-portlet__head-tools">
              <div class="col text-right align-self-center pr-0">
                <span class="btn btn-brand m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill btn-sm" @click="$refs.clientForm.create()">
                  <i class="fa fa-plus"></i> Add new client
                </span>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">

            <div class="row" v-if="loading">
              <loader></loader>
            </div>
            <template v-else>
              <div v-if="clients.length" class="row pt-1 pb-1" v-for="client, client_index in clients">
                <div class="col-12">

                  <!--client start-->
                  <div class="row client light-hover pointer" @click="toggleClient(client.id)">
                    <div class="col client-name-col align-self-center">
                      <span class="m-badge m-badge--primary m-badge--dot"></span>
                      {{ client.name }} <strong>{{ client.price_per_hour }} €/h</strong>
                    </div>
                    <div class="col-auto">
                      <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-success m-btn--icon m-btn--icon-only m-btn--pill" title="Add new project" @click.stop="createProject(client)">
                        <i class="la la-plus"></i>
                      </div>
                      <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="Edit" @click.stop="$refs.clientForm.edit(client)">
                        <i class="la la-pencil"></i>
                      </div>
                      <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete" @click.stop="tryToDestroy(client.id, client_index)">
                        <i class="la la-times"></i>
                      </div>
                    </div>
                  </div>
                  <!--client end-->

                  <projects-list v-if="expandedClient == client.id" :client="client" @updateProject="loadClients" @destroyProject="destroyProject"></projects-list>

                </div>
              </div>
              <div  v-if="clients.length === 0" class="col-12" style="text-align: center" >
                There are no clients at the moment
              </div>
            </template>
          </div>
        </div>

      </div>
    </div>

    <client-form ref="clientForm" @clientCreated="appendClient" @clientUpdated="loadClients"></client-form>
    <project-form ref="projectForm" @projectCreated="appendProject"></project-form>

  </div>
</template>
<script>
  import ClientForm from './ClientForm'
  import ProjectsList from './projects/Index'
  import ProjectForm from './projects/ProjectForm'

  export default {
    components: {
      'client-form': ClientForm,
      'projects-list': ProjectsList,
      'project-form': ProjectForm
    },
    created() {
      this.loadClients()
    },
    data() {
      return {
        clients: [],
        expandedClient: false,
        loading: true
      }
    },
    methods: {

      /* CLIENTS */

      loadClients() {
        this.axios.get('/clients').then(response => {
          this.clients = response.data.data
          this.loading = false
        });
      },
      toggleClient(id) {
        if (this.expandedClient === id) {
          this.expandedClient = false
        } else {
          this.expandedClient = id
        }
      },
      appendClient(client) {
        this.clients.push(client)
      },
      tryToDestroy(client_id, client_index) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          focusCancel: true,
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.destroyClient(client_id, client_index)
          }
        })
      },
      destroyClient(client_id, client_index) {
        this.axios.delete('/clients/' + client_id).then(result => {
          if (result.status === 204) {
            this.clients.splice(client_index, 1);
          }
        })
      },

      /* PROJECTS */

      createProject(client) {
        this.$refs.projectForm.create(client)
        this.expandedClient = client.id
      },
      appendProject(project) {
        this.clients[this.clientIndex(project.client_id)].projects.push(project)
      },
      destroyProject(project_id) {
        this.loadClients()
      },

      /* HELPERS */

      clientIndex(id) {
        for (let key in this.clients) {
          if (id === this.clients[key].id) {
            return key
          }
        }
      },
      projectIndex(id) {
        for (let key in this.projects) {
          if (id === this.projects[key].id) {
            return key
          }
        }
      },
    }

  }
</script>
<style lang="scss" scoped>
  .pointer {
    cursor: pointer;
  }

  .light-hover:hover {
    background: #fafafa;
  }

  .client {
  }

  .client, .project {
    padding: 5px 0 5px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/clients/Index.vue